var _a;
import { writable } from "svelte/store";
const accessTokenStorageKey = "_at";
const localAccessToken = window.localStorage.getItem(accessTokenStorageKey);
export const accessToken = writable(localAccessToken !== null && localAccessToken !== void 0 ? localAccessToken : null);
accessToken.subscribe((value) => window.localStorage.setItem(accessTokenStorageKey, value));
const refreshTokenStorageKey = "_rt";
const localRefreshToken = window.localStorage.getItem(refreshTokenStorageKey);
export const refreshToken = writable(localRefreshToken !== null && localRefreshToken !== void 0 ? localRefreshToken : null);
refreshToken.subscribe((value) => window.localStorage.setItem(refreshTokenStorageKey, value));
const lastUsernameStorageKey = "_un";
const localLastUsername = window.localStorage.getItem(lastUsernameStorageKey);
export const lastUsername = writable(localLastUsername !== null && localLastUsername !== void 0 ? localLastUsername : null);
lastUsername.subscribe((value) => window.localStorage.setItem(lastUsernameStorageKey, value));
const localUserDataStorageKey = "_ud";
const localUserData = window.localStorage.getItem(localUserDataStorageKey);
export const userData = writable(localUserData ? JSON.parse(localUserData) : null);
userData.subscribe((value) => window.localStorage.setItem(localUserDataStorageKey, JSON.stringify(value)));
const permissionsWereRequestedStorageKey = "permissions";
const localPermissionsWereRequested = ((_a = window.localStorage.getItem(permissionsWereRequestedStorageKey)) !== null && _a !== void 0 ? _a : 'false') === 'true';
export const permissionsWereRequested = writable(localPermissionsWereRequested !== null && localPermissionsWereRequested !== void 0 ? localPermissionsWereRequested : false);
permissionsWereRequested.subscribe((value) => window.localStorage.setItem(permissionsWereRequestedStorageKey, value ? 'true' : 'false'));
